var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrevReview(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.62064 12.6219C6.79429 12.6229 6.96431 12.5722 7.10902 12.4762C7.25373 12.3802 7.36658 12.2433 7.43317 12.0829C7.49976 11.9225 7.51708 11.7459 7.48292 11.5757C7.44876 11.4054 7.36467 11.2492 7.24137 11.1269L2.6077 6.50194L7.24137 1.87701C7.406 1.71238 7.49849 1.48909 7.49849 1.25627C7.49849 1.14099 7.47579 1.02684 7.43167 0.920332C7.38755 0.813826 7.32289 0.717052 7.24137 0.635536C7.15986 0.554019 7.06308 0.489357 6.95658 0.445241C6.85007 0.401125 6.73592 0.378418 6.62064 0.378418C6.38782 0.378418 6.16453 0.470906 5.9999 0.635536L0.754233 5.8812C0.591399 6.04501 0.5 6.2666 0.5 6.49757C0.5 6.72854 0.591399 6.95013 0.754233 7.11393L5.9999 12.3596C6.08087 12.4422 6.17743 12.5079 6.28398 12.5529C6.39054 12.598 6.50496 12.6214 6.62064 12.6219Z",
    fill: "#171719"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevReview);
export default __webpack_public_path__ + "static/media/prevReview.b60d695636b5cfbfb80a889a43d4ba7c.svg";
export { ForwardRef as ReactComponent };